<template>
    <div class="TTL-switch">
        <el-switch
            v-model="param.type"
            active-text="按瀑布流显示"
            inactive-text="按列表显示"
            @change="changeType"
        />
    </div>

    <!-- 自定义组件 -->
    <Templist :value="param.listview" v-show="param.listview" />
    <Tempshow :value="param.showview" v-show="param.showview" />

</template>

<script>
import Templist from '@/views/ImageVideo/templist'; //列表显示
import Tempshow from '@/views/ImageVideo/tempshow'; //瀑布流显示
export default {
    components:{
        Templist,Tempshow
    },
    data() {
        return {
            param: {
                type:false,
                listview:false,
                showview:false,
            }
        }
    },

    mounted() {

        //初始化显示
        this.changeType();
    },

    methods: {
        
        //切换显示
        changeType() {
            this.param.listview=false;
            this.param.showview=false;
            this.param.type ? 
            this.param.showview=true : 
            this.param.listview=true;
        },

    },

}
</script>
<style lang="scss" Scoped>
.TTL-switch {width:100%;text-align:right;}
</style>